import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BlacklistFormValues } from '../../../types';
import { blacklistApi } from '../services';

export interface CreateBlackListState {
  formValues?: BlacklistFormValues;
  requestInProgress: boolean;
  createSuccess?: boolean;
}

const initialState: CreateBlackListState = {
  requestInProgress: false,
};

export const createBlacklistSlice = createSlice({
  name: 'createBlacklist',
  initialState,
  reducers: {
    onSubmit: (state, action: PayloadAction<BlacklistFormValues>) => {
      state.createSuccess = false;
      state.formValues = action.payload;
      state.requestInProgress = true;
    },
    clearCreateBlacklistState: (state) => {
      state.requestInProgress = false;
      state.formValues = undefined;
      state.createSuccess = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        blacklistApi.endpoints.createBlacklist.matchRejected,
        (
          state,
        ) => {
          state.requestInProgress = false;
          state.createSuccess = false;
        })
      .addMatcher(
        blacklistApi.endpoints.updateBlacklistSettings.matchFulfilled,
        (
          state,
        ) => {
          state.requestInProgress = false;
          state.createSuccess = true;
        })
      .addMatcher(
        blacklistApi.endpoints.updateBlacklistSettings.matchRejected,
        (
          state,
        ) => {
          state.requestInProgress = false;
          state.createSuccess = false;
      });
  },
});

export const {
  onSubmit,
  clearCreateBlacklistState,
} = createBlacklistSlice.actions;

export default createBlacklistSlice.reducer;
